// In-memory access token store — never persisted to disk.
// HttpOnly cookie holds the refresh token (set by backend, invisible to JS).
let currentAccessToken = null;

export const setAccessToken = (token) => {
  currentAccessToken = token;
};

export const getAccessToken = () => currentAccessToken;
